import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";

function FAQs({ item }) {
  const [show, setShow] = useState(true);
  const [activeHeight, setActiveHeight] = useState(0);
  const { t } = useTranslation();
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setActiveHeight(contentRef.current["clientHeight"]);
    }
  }, []);

  return (
    <>
      <div className="border-b border-gray-300 py-4 w-full">
        <button
          onClick={() => setShow(!show)}
          className="flex justify-between gap-4 w-full"
        >
          <h2
            className={`min-[460px]:text-lg min-[460px]:leading-6 leading-5 font-medium text-left ${
              show ? "text-brand-color" : "text-gray-700"
            }`}
          >
            {t(item.question)}
          </h2>
          <div>
            <FaChevronDown
              className={`mt-1.5 transition-all ${
                show ? "text-brand-color rotate-180" : " text-gray-700"
              }`}
            />
          </div>
        </button>
        {item.answerListOut && (
          <div
            className="overflow-hidden transition-all"
            style={{ height: !show ? 0 : activeHeight }}
          >
            <ul
              className={`text-gray-500 pt-1 min-[460px]:leading-6 leading-5 ml-5 ${
                show ? "block" : "hidden"
              }`}
              ref={contentRef}
            >
              {item.answerListOut.map((item, i) => (
                <li key={i} className="list-disc">
                  {t(item)}
                </li>
              ))}
            </ul>
          </div>
        )}
        {item.answer && (
          <div
            className="overflow-hidden transition-all"
            style={{ height: !show ? 0 : activeHeight }}
          >
            <p
              ref={contentRef}
              className={`text-gray-500 pt-1 min-[460px]:leading-6 leading-5 ${
                show ? "block" : "hidden"
              }`}
            >
              {t(item.answer)}
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default FAQs;
